import axios from 'axios';
import * as types from '../constants/ActionTypes';

function requestOpenCaseChecker() {
  return { type: types.REQUEST_OPEN_CASE };
}

function receiveOpenCaseCheckerError() {
  return { type: types.RECEIVE_OPEN_CASE_ERROR };
}

function receiveOpenCase(payload) {
  return { type: types.RECEIVE_OPEN_CASE, payload };
}

export default function getOpenCase() {
  return (dispatch) => {
    dispatch(requestOpenCaseChecker());
    return axios.get('/smarthelp/user-cases')
    .then((response) => {
      dispatch(receiveOpenCase(response.data && response.data.cases));
    })
    .catch(() => { dispatch(receiveOpenCaseCheckerError()); });
  };
}
